import { observer } from "mobx-react";
import React, { use, useEffect } from "react";
import { Stack, Group, Select, Timeline, Text, Center } from "@mantine/core";

import { BobsWorkspace } from "../stores/BobsWorkspace";
import TransactionsLine from "./details/transactionsLine";
import OnchainTransactionsLine from "./details/onchainTransactionsLine";
import Spreadsheet from "./spreadSheet";
import {
  TRANSACTION_FILTER_OPTIONS,
  TransactionFilterType,
} from "../helpers/transactionsList";

const TransactionsList = observer(
  ({ bobsWorkspace }: { bobsWorkspace: BobsWorkspace }) => {
    const selectedBob = bobsWorkspace.selectedBob;

    // useEffect(() => {
    //   // Ensure the transactions list is populated when this component mounts
    //   selectedBob.activatePayAttempts();
    // }, []);
    // console.log("selectedBob.transactionsList:", selectedBob.transactionsList);
    return (
      <Stack>
        {/* Toolbar: export + filter */}
        <Group
          justify="space-between"
          align="center"
          style={{ width: "100%", gap: "1rem" }}
        >
          <Spreadsheet bobsWorkspace={bobsWorkspace} />
          <Select
            size="sm"
            data={TRANSACTION_FILTER_OPTIONS}
            value={selectedBob.transactionFilterType}
            onChange={(value) =>
              selectedBob.setTransactionFilterType(
                value as TransactionFilterType
              )
            }
            placeholder="Filter transactions"
            style={{ minWidth: "200px" }}
            withCheckIcon={false}
            comboboxProps={{ withinPortal: false }}
          />
        </Group>

        {/* Timeline */}
        {selectedBob.transactionsList.length > 0 && (
          <Timeline mt="md" mb="lg" active={-1} bulletSize={32} lineWidth={2}>
            {selectedBob.transactionsList.map((line, i) =>
              line.internalModelName === "OnchainInboundTransaction" ||
              line.internalModelName === "OnchainOutboundTransaction" ? (
                <OnchainTransactionsLine
                  key={i}
                  line={line}
                  bob={selectedBob}
                />
              ) : (
                <TransactionsLine key={i} line={line} bob={selectedBob} />
              )
            )}
          </Timeline>
        )}
        {/* need below to trigger reactivity! */}
        <Center>
          <Text>{selectedBob.transactionsList.length} transactions</Text>
        </Center>
        <Center>
          <Text size="sm" c="dimmed">
            Showing {selectedBob.showHistoryDays} days of history. Go to
            Settings to adjust this.
          </Text>
        </Center>
      </Stack>
    );
  }
);

export default TransactionsList;
